import React, { useState, useEffect, useRef } from "react";
import { useMutation, useManualQuery } from "graphql-hooks";
import { useNavigate } from "react-router-dom";
import {
  Button,
  TextField,
  Typography,
  IconButton,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";

import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

import { project_url } from "../../constants/Data";

import {
  GET_TERM_TEAM_MEMBER_QUERY,
  EDIT_TEAM_TERM_EMBER_NOTES_MUTATION,
} from "../../graphQL/team_term_member_qry";

const useStyles = makeStyles(theme => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },

  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    marginTop: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  errorStyle: {
    marginLeft: 5,
    marginTop: 0,
    fontSize: 14,
    fontFamily: "Arial",
  },
  textFieldInput: {
    resize: "Vertical",
    height: "150px",
    maxHeight: "150px",
    width: "500px",
    maxWidth: "550px",
  },
}));

export default function EditTeamResourceNoteDialog({
  teamTermMemberId,
  // sprintName,
  // notes,
  closeDialog,
  handleDone,
}) {
  const classes = useStyles();
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  const [resourceName, setResourceName] = useState("");
  const [termName, setTermName] = useState("");
  const [teamName, setTeamName] = useState("");
  const [initNotes, setInitNotes] = useState("");
  const [currentNotes, setCurrentNotes] = useState("");
  const [lastUpdate, setLastUpdate] = useState("");
  const [completed, setCompleted] = useState("");
  const [userTypeName, setUserTypeName] = useState("");
  const [applyForNextSprint, setApplyForNextSprint] = useState(false);

  const formatter1 = new Intl.DateTimeFormat("en-us", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    fractionalSecondDigits: 3,
    hour12: true,
    timeZoneName: "short",
  });

  const formatter2 = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  const dayFormat = (day, format = null) => {
    const dayDate = new Date(day);
    const dayFormat =
      format !== null
        ? formatter1.formatToParts(dayDate)
        : formatter2.formatToParts(dayDate);
    if (format === "DDmonthYYYY") {
      const newFormat =
        dayFormat.find(a => a.type == "weekday").value +
        ", " +
        dayFormat.find(a => a.type == "day").value +
        " " +
        dayFormat.find(a => a.type == "month").value +
        ", " +
        dayFormat.find(a => a.type == "year").value;
      return newFormat;
    } else if (format === "monthDDYYYY") {
      const newFormat =
        dayFormat.find(a => a.type == "month").value +
        " " +
        dayFormat.find(a => a.type == "day").value +
        ", " +
        dayFormat.find(a => a.type == "year").value;
      return newFormat;
    } else if (format === "YYYYmonthDD") {
      const newFormat =
        dayFormat.find(a => a.type == "weekday").value +
        ", " +
        dayFormat.find(a => a.type == "year").value +
        ", " +
        dayFormat.find(a => a.type == "month").value +
        " " +
        dayFormat.find(a => a.type == "day").value;
      return newFormat;
    } else {
      const newFormat =
        dayFormat.find(a => a.type == "month").value +
        "/" +
        dayFormat.find(a => a.type == "day").value +
        "/" +
        dayFormat.find(a => a.type == "year").value;
      return newFormat;
    }
  };

  const [getTermTeamMemberDataQuery] = useManualQuery(GET_TERM_TEAM_MEMBER_QUERY);
  const getTermTeamMemberData = async () => {
    const { loading, error, data } = await getTermTeamMemberDataQuery({
      variables: {
        teamTermMemberId: parseInt(teamTermMemberId),
      },
    });
    if (!loading && data && data.getTermTeamMember) {
      let resourceName = data.getTermTeamMember.userTypeId.typeName + ": ";
      resourceName += data.getTermTeamMember.userId.firstName + " ";
      resourceName += data.getTermTeamMember.userId.lastName + " ";
      setResourceName(resourceName);
      let lastUpdate = "";
      if (data.getTermTeamMember.noteUpdateBy)
        lastUpdate =
          dayFormat(data.getTermTeamMember.noteUpdateDate, "monthDDYYYY") +
          " - " +
          data.getTermTeamMember.noteUpdateBy.split(":")[1];
      setLastUpdate(lastUpdate);
      setCurrentNotes(data.getTermTeamMember.note);
      setInitNotes(data.getTermTeamMember.note);
      setTermName(data.getTermTeamMember.teamTermId.termId.name);
      setTeamName(
        data.getTermTeamMember.teamTermId.teamId.name +
          " - " +
          data.getTermTeamMember.roleId.roleName,
      );
      setCompleted(data.getTermTeamMember.completed);
      setUserTypeName(data.getTermTeamMember.userTypeId.typeName);
      // if (data.getTermTeamMember.available == true)
      //   setApplyForNextSprint(false)
      // else
      //   setApplyForNextSprint(true)
      setApplyForNextSprint(data.getTermTeamMember.applyNextTerm);
    }
    if (error) {
      navigate(`${project_url}/signin`);
    }
  };

  useEffect(() => {
    (() => getTermTeamMemberData())();
  }, []);

  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };

  const handleChange = event => {
    setCurrentNotes(event.target.value);
  };

  const handleCompletedRadioChange = event => {
    setCompleted(event.target.value);
  };

  const handleNextSprintRadioChange = event => {
    setApplyForNextSprint(event.target.value);
  };

  const [editTeamTermMemberNotes] = useMutation(EDIT_TEAM_TERM_EMBER_NOTES_MUTATION);

  const handleSave = async () => {
    let available = true;
    if (JSON.parse(applyForNextSprint) == true) available = false;
    const { loading, data, error } = await editTeamTermMemberNotes({
      variables: {
        teamTermMemberId: parseInt(teamTermMemberId),
        notes: currentNotes.trim(),
        completed: JSON.parse(completed),
        available: available,
        applyNextTerm: JSON.parse(applyForNextSprint),
      },
    });
    if (error) {
      alert("Unfortunately an error occurred.");
    } else if (data && data.editTeamTermNotes) {
      handleClose();
    } else handleClose();
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              height: "100%",
              maxWidth: "600px",
              maxHeight: "650px",
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingBottom: 4,
          }}
        >
          <Box mt={1} ml={1}>
            <Typography
              variant="h3"
              style={{
                fontSize: 18,
                padding: 3,
                marginBottom: "0.2rem",
                color: "#000",
              }}
            >
              Notes for {resourceName}
            </Typography>
            <Typography
              variant="h3"
              style={{
                fontSize: 18,
                padding: 3,
                marginBottom: "0.2rem",
                color: "#000",
              }}
            >
              Term: {termName}
            </Typography>

            <Typography
              variant="h3"
              style={{
                fontSize: 18,
                padding: 3,
                marginBottom: "0.1rem",
                color: "#000",
              }}
            >
              Team: {teamName}
            </Typography>
          </Box>

          {closeDialog ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                align: "right",
                color: theme => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Box style={{ width: "fit-content" }}>
              <Typography
                variant="h3"
                style={{
                  fontSize: 15,
                  padding: 5,
                  marginBottom: "1rem",
                  color: "#000",
                }}
              >
                Last Updated: {lastUpdate}
              </Typography>

              <TextField
                id="teamTermMemberNotes"
                variant="outlined"
                multiline
                fullWidth
                autoFocus
                required
                label="Team Term Resource Notes"
                margin="normal"
                name="teamTermMemberNotes"
                rows={3}
                className={classes.textFieldStyle}
                value={currentNotes}
                InputProps={{
                  classes: {
                    input: classes.textFieldInput,
                  },
                }}
                onChange={handleChange}
              />

              <Typography
                variant="h3"
                style={{
                  fontSize: 18,
                  marginTop: "1rem",
                  marginBottom: "0.5rem",
                  color: "#000",
                }}
              >
                Completed the Sprint:&nbsp;&nbsp;
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={completed}
                  onChange={handleCompletedRadioChange}
                >
                  <FormControlLabel value="true" control={<Radio />} label="Yes" />
                  <FormControlLabel value="false" control={<Radio />} label="No" />
                </RadioGroup>
              </Typography>
              {userTypeName === "Member" ? (
                <Typography
                  variant="h3"
                  style={{ fontSize: 18, marginBottom: "0.5rem", color: "#000" }}
                >
                  Must Apply for Next Sprint:&nbsp;&nbsp;
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    value={applyForNextSprint}
                    onChange={handleNextSprintRadioChange}
                  >
                    <FormControlLabel value="true" control={<Radio />} label="Yes" />
                    <FormControlLabel value="false" control={<Radio />} label="No" />
                  </RadioGroup>
                </Typography>
              ) : (
                ""
              )}
            </Box>
          </DialogContentText>
        </DialogContent>

        <DialogActions style={{ justifyContent: "center", marginTop: 5 }}>
          <Box mb={2}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              style={{ marginRight: 5 }}
              onClick={handleSave}
            >
              Save
            </Button>
            <Button
              variant="text"
              color="primary"
              className={classes.outlinedButtonStyle}
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
